export default "__VITE_ASSET__4Sjzrsb1__"